import React from 'react';
import Button from '../Buttons/Button';
import pingu from '../../assets/svg/pingu2.svg';
import { useScreenSize } from '../../hooks/useScreenSize';

const CTA: React.FC = () => {
  const { isMobile } = useScreenSize();

  return (
    <section className="grid-container grid-padding flex-row justify-center">
      <div
        className={`cta ${isMobile ? 'flex-colomn flex-reverse gap-2' : 'flex-row-align gap-5'} `}
      >
        <div className={`cta-img ${isMobile ? 'flex-row justify-start ' : ''}`}>
          <img className="img" src={pingu} alt="" />
        </div>
        <div className="cta-caption">
          <div className="flex-colomn">
            <h1>
              <span className="tertiary-color">Pingu </span>adviseerd jou!
            </h1>

            <p className="slide-text">
              Op basis van jouw behoeften selecteert Pingu de beste keuze voor jou.
            </p>
            <div className="flex-row justify-end">
              <Button text="Vraag offerte aan" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
